import React from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/hu";
import {
  MyLeaveCalendarPathFillAfter,
  MyLeaveCalendarPathFillPrior,
  MyLeaveCalendarPathOutlineAfter,
  MyLeaveCalendarPathOutlinePrior,
} from "my-leave/components";

type MyLeaveCalendarEvent = {
  state: string;
  leaveType: string;
  // add other properties if needed
};

interface MyLeaveCalendarEventArrowProps {
  event: MyLeaveCalendarEvent;
  continues: "prior" | "after";
}

export const MyLeaveCalendarEventArrow: React.FC<
  MyLeaveCalendarEventArrowProps
> = ({ event, continues }) => {
  let pathFill, pathOutline;
  const PathFill =
    continues === "prior"
      ? MyLeaveCalendarPathFillPrior
      : MyLeaveCalendarPathFillAfter;
  const PathOutline =
    continues === "prior"
      ? MyLeaveCalendarPathOutlinePrior
      : MyLeaveCalendarPathOutlineAfter;

  const eventState = event.state;
  const eventType = event.leaveType;

  // Match CSS classes in calendar.style.ts:
  // - "recorded" and "assigned" states: ALWAYS solid green (no CSS class, uses default .rbc-event)
  // - "leave" type: solid colored fill
  // - "absence" type: white fill + colored outline
  // - "request" type: white fill + colored outline

  if (eventState === "recorded" || eventState === "assigned") {
    // Recorded/Assigned ALWAYS get solid green (no specific CSS class, use default .rbc-event)
    pathFill = <PathFill color="#2fa84f" />;
    pathOutline = null;
  } else if (eventType === "absence") {
    // Absence types: white fill + colored outline (matches CSS white background + border)
    pathFill = <PathFill color="#fff" />;
    if (eventState === "requested") {
      pathOutline = <PathOutline color="#f3aa18" />; // orange outline
    } else if (eventState === "approved") {
      pathOutline = <PathOutline color="#2fa84f" />; // green outline
    } else if (eventState === "cancelled") {
      pathOutline = <PathOutline color="#cc0033" />; // red outline
    } else {
      pathOutline = <PathOutline color="#f3aa18" />; // default orange outline
    }
  } else if (eventType === "request" || eventState === "current") {
    // Request types: white fill + colored outline
    pathFill = <PathFill color="#fff" />;
    pathOutline = <PathOutline color="#cc0033" />; // red outline
  } else {
    // Leave types and others: solid colored fill (matches CSS solid background)
    if (eventState === "approved") {
      pathFill = <PathFill color="#2fa84f" />; // solid green
    } else if (eventState === "cancelled") {
      pathFill = <PathFill color="#cc0033" />; // solid red
    } else {
      pathFill = <PathFill color="#f3aa18" />; // solid orange (requested/assigned/default)
    }
    pathOutline = null;
  }

  return (
    <div
      style={{
        overflow: "hidden",
        height: 27,
        maxHeight: 27,
        marginRight: continues === "prior" ? -6 : 0,
        marginLeft: continues === "prior" ? 1 : -6,
        zIndex: 10000,
        width: 20,
      }}
    >
      <svg
        width="20"
        height="27"
        viewBox="0 0 16 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {pathFill}
        {pathOutline}
      </svg>
    </div>
  );
};

export default MyLeaveCalendarEventArrow;
